import React from "react";

function Impressum() {
    return (
        <div className="p-8 max-w-3xl mx-auto">
            <h1 className="text-3xl font-bold mb-4">Impressum</h1>

            <p>Autoservice Groß GmbH</p>
            <p>Tannenkircher Straße 2a</p>
            <p>79415 Bad Bellingen</p>
            <p>Germany</p>

            <p className="mt-4">Telefon: 07635 1845</p>
            <p>Fax: 07635 1846</p>
            <p>
                E-Mail:{" "}
                <a
                    href="mailto:info@ford-gross.de"
                    className="text-blue-500 hover:underline"
                >
                    info@ford-gross.de
                </a>
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">Vertreten durch:</h2>
            <p>Geschäftsführer: Roger Groß</p>

            <h2 className="text-xl font-semibold mt-6 mb-2">Registereintrag:</h2>
            <p>Handelsregister: Amtsgericht Freiburg i. Br.</p>
            <p>Registernummer: HRB 410991</p>

            <h2 className="text-xl font-semibold mt-6 mb-2">Umsatzsteuer-ID:</h2>
            <p>Umsatzsteuer-Identifikationsnummer gemäß §27a UStG: DE142489782</p>

            <h2 className="text-xl font-semibold mt-6 mb-2">
                Zuständige Aufsichtsbehörde / Kammer:
            </h2>
            <p>Handwerkskammer Freiburg</p>

            <h2 className="text-xl font-semibold mt-6 mb-2">Online-Streitbeilegung:</h2>
            <p>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                    href="https://ec.europa.eu/consumers/odr"
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:underline"
                >
                    https://ec.europa.eu/consumers/odr
                </a>
            </p>
            <p>
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">Haftungshinweis:</h2>
            <p>
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
                für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten
                sind ausschließlich deren Betreiber verantwortlich.
            </p>
        </div>
    );
}

export default Impressum;
